import { MapPin, Briefcase, ArrowRight } from 'lucide-react';
import { MarketingLayout } from '../../layouts/MarketingLayout';

const openings = [
  { title: 'Staff Cryptography Engineer', team: 'Identity', location: 'London / Remote', type: 'Full-time' },
  { title: 'Senior Frontend Engineer', team: 'Web Platform', location: 'Lisbon / Remote', type: 'Full-time' },
  { title: 'Developer Advocate', team: 'Ecosystem', location: 'New York', type: 'Full-time' },
  { title: 'Governance Researcher', team: 'Policy', location: 'Remote (EMEA)', type: 'Full-time' },
  { title: 'Product Designer', team: 'Design Systems', location: 'Remote (Americas)', type: 'Full-time' },
];

const perks = [
  'Competitive salary with meaningful equity',
  'Remote-first with optional hubs in London, NYC, Lisbon',
  '30 days paid time off + local public holidays',
  'Top-tier health, dental, and mental health coverage',
  'Annual learning and conference budget',
  'Home office stipend and yearly hardware refresh',
];

export const Careers = () => {
  return (
    <MarketingLayout
      title="Careers at Keskedo"
      subtitle="Help us build the open identity layer for the next generation of the internet. We hire kind, curious, rigorous people."
    >
      <section className="space-y-12">
        <div className="space-y-6">
          <h2 className="text-2xl font-bold text-slate-900">Open roles</h2>
          <div className="space-y-3">
            {openings.map((role, i) => (
              <button
                key={i}
                className="w-full text-left p-6 bg-white border border-slate-200 rounded-2xl flex items-center justify-between gap-6 hover:shadow-lg hover:-translate-y-0.5 hover:border-indigo-100 transition-all"
              >
                <div className="space-y-1">
                  <h3 className="font-bold text-slate-900">{role.title}</h3>
                  <div className="flex flex-wrap gap-4 text-xs text-slate-500">
                    <span className="inline-flex items-center gap-1"><Briefcase size={12} />{role.team}</span>
                    <span className="inline-flex items-center gap-1"><MapPin size={12} />{role.location}</span>
                    <span>{role.type}</span>
                  </div>
                </div>
                <ArrowRight size={18} className="text-slate-400 flex-shrink-0" />
              </button>
            ))}
          </div>
        </div>

        <div className="space-y-6">
          <h2 className="text-2xl font-bold text-slate-900">Why Keskedo</h2>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {perks.map((perk, i) => (
              <li key={i} className="p-4 bg-slate-50 rounded-xl border border-slate-200 text-sm text-slate-700">
                {perk}
              </li>
            ))}
          </ul>
        </div>
      </section>
    </MarketingLayout>
  );
};
